export interface IMapSettingsModel {
    mapSettingId: number,
    label: string,
    isDisplay: boolean
}

export const mapSettingsModel: IMapSettingsModel[] =
    [
        {
            mapSettingId: 0,
            label: 'Show LCL Sea Bookings',
            isDisplay: true
        },
        {
            mapSettingId: 1,
            label: 'Show FCL Sea Bookings',
            isDisplay: true
        }
    ];
